document.addEventListener("DOMContentLoaded", async () => {
	const { initYoutubeVideos } = await import("@utils/youtubeVideo");
	initYoutubeVideos();
});
